const zh = {
  9000001: " 2023聖誕杯",
  9000002: "SuperEx合約錦標賽",
  9000003: "贏取30,000USDT競賽獎金",
  9000004: "参赛人数",
  9000005: "已解锁奖池（USDT）",
  9000006: "交易量排名资格赛",
  9000007: "盈利率排名資格賽",
  9000008: "盈利額排名資格賽",
  9000009: `交易量排名赛，解锁最高 <span style="color: #ffc72b;">20,000</span> USDT 奖金池`,
  9000010: "根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高20,000USDT獎金池",
  9000011: "奖池金额",
  9000012: "活动期间每天10:00（UTC）更新",
  9000013: "獎勵預估",
  9000014: "期間纍計期貨交易金額",
  9000015: "奖励规则",
  9000016: "根据参赛人数解锁对应奖池，参赛人数越多解锁奖池越大，最高20,000U奖金池",
  9000017: "奖池金额（USDT）",
  9000018: "活动盈利率排名",
  9000019: "报名",
  9000020: "活动盈利额排名",
  9000021: "已结束",
  9000022: `盈利率排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
  9000023: `盈利額排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
  9000024: "累计合約盈利率",
  9000025: "纍計合约盈利金額",
  9000026: "未开始",
  9000027: "參賽用戶盈利額排名前50名獲得獎勵，可參考交易排名獎勵規則獲取贈金獎勵",
  9000028: "參賽用戶盈利率排名前50名可獲得獎勵，可參考交易排名獎勵規則獲取獎勵",
  9000029: "活動交易額排名",
  9000030: "",

  //交易合约积分
  9100001: "攒积分",
  9100002: "得空投",
  9100003: "兑奖励",
  9100004: "积分余额",
  9100005: "明细",
  9100006: "签到积分",
  9100007: "交易积分",
  9100008: "邀请积分",
  9100009: "奖励积分",
  9100010: "幸运抽奖",
  9100011: "获取积分",
  9100012: "积分规则",
  9100013: "积分明细",
  9100014: "您需要报名才能参与此活动,点击即可参与",
  9100015: "已连续交易 {day} 天并获得 {num} 积分",
  9100016: "今日已得 {num} 积分",
  9100017: "积分奖池",
  9100018: "每次抽奖消耗 {point} 积分，每天最多抽 {num} 次",
  9100019: "今日抽奖次数",
  9100020: "用户",
  9100021: "积分",
  9100022: "积分余额不足",
  9100023: "积分余额不足，请获取积分后再参与抽奖",
  9100024: "抽奖次数已达上限",
  9100025: "今日抽奖次数已达上限，请明日再试。",
  9100026: "如何获得积分",
  9100027: "报名参与合约交易获积分活动，才能获得积分",
  9100028: "参与报名成功",
  9100029: "您已报名参与合约交易获积分活动，去交易获得更多积分吧(将不再享受返佣返现奖励）",
  9100030: "取消报名后，将不再获得积分，您确定要取消报名吗？",
  9100031: "交易积分活动中心",
  9100032: "获取积分",
  9100033: "您需要报名才能参与此活动,点击即可参与",
  9100034: "连续参与合约积分即可获得积分",
  9100035: "用户在合约市场产生的所有交易行为即可获取积分",
  9100036: "排行榜积分",
  9100037: "每日交易排行榜前五给与额外的奖励积分",
  9100038: "被邀请人产生积分，邀请人可获得奖励积分",
  9100039: '{guy} 已经中奖<span style="color:#D9A31A"> {num} 积分</span>',
  9100040: "立即抽奖",
  9100041: "恭喜您获得了",
  9100042: "全部类型",
  9100043: "留在此页",
  9100044: "参与报名",
  9100045: "继续交易",
  9100046: "暂无正在进行的活动，敬请期待...",
  9100047: "兑SCS代币",
  9100048: "",
  9100049: "",

  9100050: "日期",
  9100051: "起始时间",
  9100052: "结束时间",
  9100053: "到",
  9100054: "类型",

  9100055: "可获积分=交易额*1%（难度随着平台总交易量的上升会进一步调整）",
  9100056: "例如:用户使用保证金100USDT*100X=10000U的仓位",
  9100057: "那么只需要100USDT的保证金即可获得100积分",
  9100058: "交易积分是获取平台代币SCS的唯一渠道",
  9100059: "额外奖励积分=当日积分总额*名次奖励比例",
  9100060: "名次",
  9100061: "第一名",
  9100062: "第二名",
  9100063: "第三名",
  9100064: "第四名",
  9100065: "第五名",
  9100066: "被邀请人产生积分，邀请人可获得奖励积分",
  9100067: "等级系数",
  9100068: "计算公式：获得推广积分= 被邀请人获得积分 * 等级系数",
  9100069: "等级系数会根据实际情况进行调整",
  9100070: `例如：用户B参与积分活动，其邀请人为用户A，且用户A邀请数量等级已达到Level3，用户B累计获得积分=360,000；`,
  9100071: "那么用户A累计可获的推广积分=360000* 30%=108,000",
  9100072: "奖励系数",
  9100073: "1个交易用户",
  9100074: "交易量达到500W",
  9100075: "交易量达到2000W",

  9100076: "划转",

  //热币
  9100080: "距离活动结束",
  9100081: "点击「报名参加」赢大奖",
  9100082: "查看规则",
  9100083: "报名参加",
  9100084: "活动",
  9100088: "去交易",
  9100089: "去充值",
  9100090: "您已报名该活动",

  9100091: "本次活动已结束，敬请期待下一次活动！",
  9100092: "活动未开始，敬请期待",
  9100093: "",
  9100094: "",

  //api key
  9100105: "创建api key",
  9100106: "查看 API 文档",
  9100107: "一体化交易系统",
  9100108: "创建/管理 API Key",
  9100109: "部署API",
  9100110: "交易和请求",
  9100111: "领先的数字资产交易平台",
  9100112: "丰富的数字资产交易及资产管理服务，满足多样化交易需求。",
  9100113: "提供更好的服务",
  9100114: "更优的交易费率、更高的交易金额、更灵活的账户管理功能等。",
  9100115: "千万用户信赖之选",
  9100116: "确保安全的交易环境，提供专业的客户支持，助您在数字资产的世界中稳步前行。",
  9100117: "如何在 SuperEx 创建 API Key？",
  9100118: "SuperEx 的 API 文档在哪里可以查看？",
  9100119: "在 SuperEx 交易发现了问题怎么办？",
  9100120: "如何使用 SuperEx 的 API？",
  9100121: "接入 SuperEx API，交易更快更流畅",
  9100122: `您在登录的状态下，鼠标悬停于头像-“API管理”，点击“创建API Key”，创建您在 SuperEx 的 API Key。注:如果您未登录的话，需要您先登录您在 SuperEx 的账号。
也可以从底部导航栏“APIs”进入，创建您在SuperEx的API Key。`,
  9100123: '您可以点击<a style="color:#d1a53e">API文档</a>，查看 SuperEx 的API文档',
  9100124: `"使用过程中如有问题或者建议，您可选择以下方式联系我们：<br>通过官网的“帮助中心”或者发送邮件至客服邮箱support@superex.com联系客服。"`,
  9100125: `使用 SuperEx 的API，你首先需要：<br>注册并登录 SuperEx 账户。<br>创建一个API Key，这会为你生成一个access_key和secret_key。<br>使用此access_key和secret_key来签名你的请求。<br>根据你的需求，你可以使用 SuperEx 提供的不同API，如市场数据API、交易API、账户API等。每次请求时都需要遵循API文档中的指示，并确保你的请求有适当的HTTP头和签名。`,
  9100126: "API key管理",
  9100127: "创建新API Key",
  9100128: "备注名",
  9100129: "请输入备注名",
  9100130: "权限设置（可多选）",
  9100131: "读取",
  9100132: "交易",
  9100133: "绑定IP地址（选填）",
  9100134: "多个IP地址请用英文逗号隔开，最多填写10个地址",
  9100135: "我已阅读并同意",
  9100136: "API用户风险提示",
  9100137: "创建",
  9100138: `SuperEx为您提供了强大的API，您可以通过API使用行情查询、自动交易等服务。通过【API文档】查看如何使用。`,
  9100139: "每个用户最多创建10组API Key",
  9100140: `未绑定IP的API Key，将在90天后自动失效。如长期
使用，您可在下方“我的API Key —— 操作—— 续签”，
将您的API Key有效期顺延90天。已绑定IP的 API key
无有效期限制。`,
  9100141: "我的API Key",
  9100142: "权限",
  9100143: "绑定IP地址",
  9100144: "续签",
  9100145: "创建API Key需要您向现货钱包充值任意金额激活账户",
  9100146: "确认续签当前API Key",
  9100147: "请不要泄露您的API Key，以免造成资产损失。",
  9100148: `出于安全考虑，建议为API Key绑定IP，每个API Key最多
绑定10个IP地址。单个IP地址直接填写，多个IP地址用
半角逗号分隔，如：192.168.1.1,192.168.1.2`,
  9100149: "续签成功后到期时间会重新计算。如您长期使用API Key，建议绑定IP地址，绑定后API Key不会失效同时也更加安全。",
  9100150: "确认删除当前API Key",
  9100151: "您需要了解以下风险：",
  9100152: `API Key跟您的账号安全紧密相关，凡知晓您API Key的
第三方均有可能控制您账户资产，因此请您妥善保管，
请不要向任何第三方透露您的API Key，并不上传至
第三方网站和论坛。`,
  9100153: `因您个人原因导致API Key泄露而涉及的包括但不限于
资产安全问题、经济损失问题等，您自行承担由此产生的
全部责任，我们不对此承担责任。`,
  9100154: "风险提示",
  9100155: "我已知悉并愿意承担风险",
  9100156: "我已保存",
  9100157: "权限设置",
  9100158: "密钥仅显示一次，遗失后不可找回，请务必妥善保存。",
  9100159: "请不要泄露您的Access Key 及Secret Key，以免造成资产损失。",
  9100160: "如您忘记了Secret Key，请删除该密钥对并申请新的密钥对。",
  9100161: "我们提供功能强大的API，帮助您高效地将交易功能整合至应用中。API分为账户、交易和行情三类，您可根据需求配置相应权限，并通过API实现自动交易。",
  9100162: "创建时间",
  9100163: "创建新API Key",
  9100164: "编辑",
  9100165: "到期时间",
  9100166: "删除",
  9100167: "创建成功",
  9100168: "温馨提示",
  9100169: "知道了",
  9100170: "API用户风险提示",
  9100171: "IP地址格式不正确",
  9100172: "",
  //自由区二维码分享页面
  9100095: "自由区上币，开启财富自由",
  9100096: "打开APP",
  9100097: "",
  9100098: "",

  //代理商
  101738: "成为 SuperEx 代理商享高额返佣",
  101739: "邀请好友来 SuperEx 交易，可获得50%手续费返佣，好友进行合约交易后，您可享有返佣。",
  101740: "成为代理商",
  101741: "如何获得佣金？",
  101742: "申请成为代理商",
  101743: "拥有社区、媒体等资源即可申请代理商，申请成功后，您可升级为代理商",
  101744: "推广 SuperEx",
  101745: "将您的邀请链接分享给您的社区、粉丝或您的其他渠道进行宣传曝光",
  101746: "获得佣金收益",
  101747: "新用户通过您的邀请链接注册并交易，您可以获得佣金",
  101748: "我能赚取多少佣金？",
  101749: "邀请用户来 SuperEx 交易，您可以获得好友手续费的20%作为邀请奖励。",
  101750: "您成为 SuperEx 代理商，您还可以获得50%的代理商返佣奖励 ",
  101751: "为什么成为 SuperEx 代理商？",
  101752: "高额返佣",
  101753: "50%手续费返佣",
  101754: "流量扶持",
  101755: "专业流量扶持，轻松获取收益",
  101756: "品牌加持",
  101757: "全球线下活动，定制联合礼品周边",
  101758: "全球线下活动",
  101759: "SuperEX全球线下粉丝会，业内顶尖会议，全方位扶持每一位代理商，帮其提升收益",
  101760: "审核未通过",
  101761: "代理商",
  101762: "渠道管理",
  101763: "创建渠道",
  101764: "所属渠道",
  101765: "推广方式",
  101766: "渠道名称",
  101767: "创建时间",
  101768: "编辑",
  101769: "合约返佣比例",
  101770: "现货返佣比例",
  101771: "推广管理",
  101772: "创建代理商邀请码",
  101773: "邀请码",
  101774: "剩余可创建推广链接数量",
  101775: "邀请人数",
  101776: "代理商邀请码",
  101777: "代理商邀请人数",
  101778: "常规邀请码数量",
  101779: "常规邀请人数",
  101780: "邀请链接",
  101781: "常规渠道",
  101782: "数据看板",
  101783: "入金人数",
  101784: "交易额",
  101785: "佣金",
  101786: "所属邀请码",
  101787: "移动邀请关系",
  101788: "合约报表",
  101789: "现货报表",
  101790: "交易笔数",
  101791: "结算中心",
  101792: "合约结算",
  101793: "现货结算",
  101794: "预估佣金",
  101795: "提现记录",
  101796: "查看资产",
  101797: "已提现金额",
  101798: "累计佣金",
  101799: "当前代币暂不满足提现金额，您可以邀请更多用户进行交易获得奖励金。",
  101800: "合约数据概览",
  101801: "现货数据概览",
  101802: "合约明细",
  101803: "现货明细",
  101804: "全部方向",
  101805: "代理商预估佣金",
  101806: "用户预估佣金",
  101807: "成交时间",
  101808: "详细规则请查看 SuperEx 公告",
  101809: "代理商计划申请表单",
  101810: "您的语言",
  101811: "您在哪个国家？（例如：伊朗）",
  101812: "您的主要平台/渠道时什么？",
  101813: "您在平台/社交媒体/网站上有多少关注者/粉丝/用户？",
  101814: "填写您的主要平台/频道链接（输入完整的URL）",
  101815: "其他社交渠道/网站链接（输入完整的URL）",
  101816: "您的名字",
  101817: "填写快速与您联系的社交媒体渠道（例如：Telegram id @xxx）",
  101818: "您是从哪了解到代理商计划？",
  101819: "朋友",
  101820: "您可以与我们分享的其他信息，例如关于您自己的和您频道简单介绍",
  101821: "太棒了",
  101822: "您已成功完成 SuperEx 代理商申请。通过审核后，我么将会通过电子邮件通知您。",
  101823: "时间段的跨度不能超过3个月",
  101824: "操作成功",
  101825: "全部提现",
  101826: "已提现",
  101827: "当前代币暂不满足提现金额，您可以邀请更多用户进行交易获得奖励金。",
  101828: "用户管理",
  101829: "用户ID",
  101830: "合约返现比例",
  101831: "现货返现比例",
  101832: "注册时间",
  101833: "交易明细",
  101834: "买入开多",
  101835: "卖出开空",
  101836: "卖出平多",
  101837: "买入平空",
  101838: "提现时间",
  101839: "提现币种",
  101840: "提现数量",
  101841: "用户佣金",
  101842: "可提现金额",
  101843: "提现",
  101844: "社区",
  101845: "邮箱（此邮箱将用于接收代理商信息，如果未发现验证信息，请查阅您的垃圾邮箱）",
  101846: "验证码",
  101847: "申请正在审核中，请耐心等待。通过审核后，我们将会通过电子邮件通知您。",
  101848: "抱歉，您的代理商申请未通过",
  101849: "重新申请",
  101850: "数据概览",
  101851: "代理商合约返佣比例",
  101852: "代理商现货返佣比例",
  101853: "您已被取消代理商资格，如有疑问请联系管理员",
  101854: "全部时间",
  101855: "昨日",
  101856: "本月",
  101857: "上月",
  101858: "交易人数",
  101859: "总入金",
  101860: "请选择邀请码",
  101861: "总收益",
  101862: "合约佣金",
  101863: "现货佣金",
  101864: "待提现",
  101865: "已提现",
  101866: "待解锁",
  101867: "*佣金收益需提现至我的现货账户才能使用",
  101868: "提现确认",
  101869: "您是否确认要将所有代币全部提现到我的现货账户？",
  101870: "当前代币暂不满足提现金额，您可以邀请更多用户进行交易获得奖励金。",
  101871: "已解锁",
  101872: "已冲正",
  101873: "已取消代理商资格",
  101874: "已为代理商",
  101875: "渠道数据概览",
  101876: "用户数据",
  101877: "到云钱包合约账户",
  101878: "到云钱包现货账户",
  101879: "现货交易明细",
  101880: "合约交易明细",
  101881: "合约结算中心",
  101882: "现货结算中心",
  101883: "效果报表",
  101884: "请选择语言",
  101885: "请输入您的答案",
  101886: "请选择渠道名称",
  101887: "佣金提现",
  101888: "请输入渠道名称",
  101889: "请选择推广方式",
  101890: "请输入备注内容",
  101891: "可提现资产",
  101892: "确认提现",
  101893: "设置用户合约返现比例",
  101894: "设置用户现货返现比例",
  101895: "合约效果报表",
  101896: "现货效果报表",
  101897: "折合(USDT)",
  101898: "提现到云钱包",
  101899: "确定将现货佣金全部提现到云钱包吗？",
  101900: "查看资金",
  101901: "全部币种",
  101902: "未提现",
  101903: "总佣金",
  101904: "请选择国家或地区",
  101905: "请填写验证码",
  101906: "代理商系统",
  101907: "谢谢",
  101908: "您的申请已送出。我们一般在2-3个工作日内审核你的信息，通过审核后将生效你的返佣",
//代理商拉新
92000000:'活动倒计时',
92000001:'参与方式',
92000002:'您需要确保完成任务的账号与您在当前页面的注册/登录账号保持一致，这样才有机会赢得奖励。',
92000003:'等待任务验证',
92000004:'应 <span style="color:#000922;font-weight:500;">{brokerName}</span> 邀请注册 SuperEx 账户，可解锁限时迎新奖励!',
92000005:`从 {time} 开始`,
92000006:`至 {time} 完成`,
92000007:'任务完成验证最多需要 7 工作日，请耐心等待。',
92000008:'活动结束后约 7 天内',
92000009:'验证任务无误后，活動獎勵將在活動結束後7個工作日內發放至賬戶。',
92000010:'使用 <span style="color:#000922;font-weight:400;">{brokerName}</span> 的邀请链接注册',
92000011:'条款与条件',
92000012:'活动进行中',
92000013:'无法参与此活动',
92000014:'活动已结束',
92000015:'领取奖励',
92000016:'立即登录',
92000017:'请设置昵称',

92000018:'备注',
92000019:'该项为必填项',
92000020:'保存',
92000021:'分享海报',
92000022:'最大',
92000023:'编辑所属渠道',
92000024:'创建所属渠道',
92000025:'该渠道下无邀请码',
92000026:'',
92000027:'',
92000028:'',
92000029:'',
92000030:'',
};
export default zh;



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/zh.js